import { AppError } from "@micd-lti/shared";
import "./error.css";
import { getErrorMessage } from "./get-error-message";

const errorContainer = document.createElement("div");

errorContainer.id = "error-container";

errorContainer.innerHTML = `
  <div class="error-content">
    <img src="${import.meta.env.BASE_URL}logo.svg" width="60" height="60" alt="MathICanDo" />
    <h1>An error has occurred</h1>
    <p id="error-message"></p>
    <p class="support-text">
      Please try again or contact
      <a href="mailto:${import.meta.env.VITE_SUPPORT_EMAIL}">${import.meta.env.VITE_SUPPORT_EMAIL}</a> for support.
    </p>
  </div>
`;

export const showError = (error: AppError | Error | unknown) => {
  document.body.innerHTML = "";
  document.body.appendChild(errorContainer);

  const errorMessage = document.getElementById("error-message");

  if (errorMessage) {
    if (error instanceof AppError) {
      errorMessage.textContent = error.statusCode + ": " + error.message;
      return;
    }

    errorMessage.textContent = getErrorMessage(error);
  }
};
